// modules
import { addModal } from 'weblite-web-modal-viewer'
// component
import { LinkMenu } from './link-menu'

const COMPONENT_ID = 'linkMenu'

interface Prop {
  link: string
}

export const showLinkMenu = ({ link }: Prop, preventBackClick = false) =>
  addModal({
    id: COMPONENT_ID,
    props: { link },
    preventBackClick,
  })

export default {
  [COMPONENT_ID]: { Component: LinkMenu },
}
